export default "__VITE_ASSET__Be4T1Fmi__"